import React from 'react';
import { connect } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Linker from '../../../presentation/linker/Linker';
import * as path from '../../../../route/PathConfig';
import './DropdownUser.css';
import { logoutRequest } from '../../../../actions/authentication';
import { useHistory } from 'react-router-dom';

const DropdownUser = (props) => {
  let history = useHistory();

  const handleLogout = () => {
    return props.logoutRequest().then(()=>{
      let loginData = {
        isLoggedIn: false,
        email: ''
      };

      document.cookie = 'key=' + btoa(JSON.stringify(loginData));
      history.push(`${path.DEFAULT}`);
      return true;
    });
  }

  return (
    <div id="admin">
      <OverlayTrigger 
        trigger="click"
        key="bottom"
        rootClose={true}
        placement="bottom"
        overlay={
          <Popover id="popover-positioned-bottom">
            <Popover.Content>
              <div className="user-dropdown-menu">
                <span style={{fontWeight:"bold"}}>{props.email}</span><br />
                <div style={{textAlign: 'center'}}>
                  <Linker path={path.ACCOUNT}>
                    <a className="button purple" style={{display: "inline-block", margin: "7px 10px 0px 0px"}}>Account</a>
                  </Linker>
                  {/* <Linker path={path.HOME}>
                    <a onClick={logoutRequest}>Logout</a>
                  </Linker> */}
                  <a onClick={handleLogout} className="button purple_line" style={{display: "inline-block", margin: "7px 10px 0px 0px"}}>Logout</a>
                  </div>
              </div>
            </Popover.Content>
          </Popover>
        }
      >
        <a className="tooltip-email">{props.email}</a>
      </OverlayTrigger>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
      status: state.AuthManager.status
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      logoutRequest: () => {
          return dispatch(logoutRequest());
      }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DropdownUser);